export type BeneficiaryStaffMembersUpdatedPayload = {
	readonly nursingStaffMemberId: number | null;
	readonly homeCareStaffMemberId: number | null;
};

export type BeneficiaryStaffMembersUpdatedAction = {
	type: 'BENEFICIARY_STAFF_MEMBERS_UPDATED';
	payload: BeneficiaryStaffMembersUpdatedPayload;
	beneficiaryId: number;
};

// The `204` response carries no body: the mutation is applied from what the screen already holds
// (the id it just selected), not from anything the server returns — this action transports the
// member's id, not its identity, so `BeneficiaryView` rebuilds its display name from `staffMembersStore`.
export default (
	payload: BeneficiaryStaffMembersUpdatedPayload,
	beneficiaryId: number,
): BeneficiaryStaffMembersUpdatedAction => ({
	type: 'BENEFICIARY_STAFF_MEMBERS_UPDATED',
	payload,
	beneficiaryId,
});
